import React from 'react';
import { SortMethod } from '../../types';

interface SortControlsProps {
  activeSort: SortMethod;
  onSortChange: (sort: SortMethod) => void;
  className?: string;
}

export const SortControls: React.FC<SortControlsProps> = ({
  activeSort,
  onSortChange,
  className = '',
}) => {
  const sortOptions: { value: SortMethod; label: string }[] = [
    { value: 'default', label: 'Par défaut' },
    { value: 'az', label: 'A-Z' },
    { value: 'za', label: 'Z-A' },
  ];

  return (
    <div className={`flex gap-2 ${className}`}>
      {sortOptions.map((option) => (
        <button
          key={option.value}
          type="button"
          onClick={() => onSortChange(option.value)}
          className={`
            px-3 py-1.5
            text-sm font-medium
            rounded-full
            border transition-all duration-200
            ${
              activeSort === option.value
                ? 'bg-primary text-white border-primary'
                : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
            }
          `}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};
